import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { initSentry } from './lib/sentry';
import { initWebVitals } from './lib/vitals';

// Initialize Sentry for error tracking (before rendering)
initSentry();

// Suppress all WebSocket and promise rejection errors in development environment
window.addEventListener('unhandledrejection', (event) => {
  if (
    event.reason?.message?.includes('WebSocket') ||
    event.reason?.message?.includes('Failed to construct') ||
    event.reason?.name === 'DOMException'
  ) {
    // Suppress WebSocket and DOM errors that occur in development
    event.preventDefault();
  }
});

// Render the app
createRoot(document.getElementById('root')!).render(<App />);

// Initialize Web Vitals monitoring (after render)
initWebVitals();
